import { render, staticRenderFns } from "./ideaBook.vue?vue&type=template&id=4b8c1330&scoped=true&"
import script from "./ideaBook.vue?vue&type=script&lang=js&"
export * from "./ideaBook.vue?vue&type=script&lang=js&"
import style0 from "./ideaBook.vue?vue&type=style&index=0&id=4b8c1330&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8c1330",
  null
  
)

export default component.exports